export const LS_ONBOARDING_V1_KEY = 'lsonboardingV1';
export const LS_NEW_CHAR_KEY = 'lsnewchar';
export const LS_DISCOUNT_TIMER_KEY = 'lsdisctimer';
export const LS_SIGNOUT_DATE_KEY = 'lssignodate';
export const LS_MSG_DRAFTS_KEY = 'lsmdrafts';
export const LS_ENDORSELY_AFFILIATE_REF_KEY = 'lsndlyaffref';
export const LS_OFFLINE_REFRESH_TSTMP_KEY = 'lsoffrefreshtstmp';

export const SESSION_IS_STANDALONE_MODE_KEY = 'lsisstandalone';
export const SESSION_HAS_ANDROID_TWA_REFERRER_KEY = 'lshasandroidtwaref';
export const SESSION_HAS_PLAYSTORE_TWA_HASH_KEY = 'lshaspstoretwahash';

export const MAX_UI_MESSAGES = 500;

export const TWA_PACKAGE_NAME = 'ai.eveninghoney.www.twa';
export const TWA_START_URL_HASH = '#playstore-twa';